export class FunctionExecRequest
{
    constructor(
            public readonly functionId:number,
            public readonly executionId:string,
            public readonly parameterValues:any,
            public readonly timeoutMillis:number
        )
    {}
}
